import Config from './config';

export default class PlatformApiClient {

  static get DEVICE_ID() {
    return {
      SP: 4,
    };
  }

  constructor(clientId) {
    this.platformApi = Config.PLATFORM_API.URL_BASE.EXTERNAL;
    this.clientId = clientId;
  }

  findAnnouncements(options) {
    options.client_id = this.clientId;
    const url = new URL('/cosme/v1/informations/notices', this.platformApi);
    Object.keys(options).forEach((key) => url.searchParams.set(key, options[key]));

    return fetch(url.toString(), {
      mode: 'cors',
    }).then((response) => {
      if (!response.ok) {
        throw new Error(response.status + ' ' + response.statusText);
      }
      return response.json();
    });
  }
}
